import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthFacade } from '../../store/state/auth/index';

interface ShowDirectiveParams<T> {
  permission: string;
  else?: TemplateRef<T>;
}

@Directive({ selector: '[show]' })
export class ShowDirective<T> {
  constructor(
    private templateRef: TemplateRef<T>,
    private viewContainer: ViewContainerRef,
    private authFacade: AuthFacade,
  ) {}

  @Input() set show(params: string | ShowDirectiveParams<T>) {
    if (typeof params === 'string') {
      this.checkPermissionAndShow(params);
    } else {
      this.checkPermissionAndShow(params.permission, params.else);
    }
  }

  private checkPermissionAndShow(permission: string, templateRef?: TemplateRef<T>): void {
    this.authFacade.hasPermission$(permission).subscribe((condition: boolean) => {
      switch (true) {
        case condition:
          this.viewContainer.createEmbeddedView(this.templateRef);
          break;
        case !!templateRef:
          this.viewContainer.createEmbeddedView(templateRef);
          break;
        default:
          this.viewContainer.clear();
      }
    });
  }
}
